import Color from 'color';

import View from '@/components/atomic/atoms/layout/view/styled';
import { BackdropProps } from '@/components/atomic/atoms/utils/portals/backdrop/typings';
import DropdownContainerStyled from '@/components/atomic/atoms/utils/portals/dropdown-container/styled';
import styled from '@emotion/styled';

const Backdrop = styled(View)<BackdropProps>(({ theme, $opacity }) => {
	return {
		position: 'fixed',
		left: 0,
		top: '0',
		height: '100dvh',
		width: '100dvw',
		backgroundColor: theme.colors.backdrop,
		zIndex: 99,
		opacity: $opacity === undefined ? 1 : $opacity,
		cursor: 'pointer',
		':hover': {
			backgroundColor: theme.colors.backdrop,
		},
		[`&:has(~ ${DropdownContainerStyled}.sidebar-panel)`]: {
			zIndex: 101,
			backgroundColor: `${Color(theme.colors.primaryBrandColor).alpha(0.3)}`,
		},
	};
});

export default Backdrop;
